var map = {
	"./checkmark-circle.svg": "VgLS",
	"./checkmark.svg": "JYSj",
	"./chevron-left.svg": "xFm4",
	"./comment-dots.svg": "kIZn",
	"./info.svg": "LBsk",
	"./laptop-house.svg": "AZ+l",
	"./logo.svg": "w+EQ",
	"./pencils.svg": "bEI4",
	"./x.svg": "0IKL"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "Ms+j";